// @flow
import { getAuthToken, getBidderEmail, getUserData } from './user';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { getSetPasswordAnalytics } from './analytics';
import type { GlobalState } from '../rootReducer';
import { openCompleteAccountModal } from './modal';
import { postSetPassword } from '../api/bidder';
import { submitLogin } from './login';

/* Action Types */
export const SET_PASSWORD_FAIL = 'la/ui/setPassword/FAIL';
export const SET_PASSWORD_REQUEST = 'la/ui/setPassword/REQUEST';
export const SET_PASSWORD_SUCCESS = 'la/ui/setPassword/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case SET_PASSWORD_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false,
            };
        case SET_PASSWORD_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: '',
                submitted: true,
                success: false,
            };
        case SET_PASSWORD_SUCCESS:
            return {
                ...state,
                error: false,
                errorMessage: '',
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.setPassword;

export const getUiSetPassword = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
export const submitSetPassword = (password: string, attributionData: any) => async (
    dispatch: Function,
    getState: Function,
) => {
    let emailAddress = '';
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        emailAddress = getBidderEmail(state);
        const userData = getUserData(state);

        await dispatch({
            type: SET_PASSWORD_REQUEST,
        });
        await postSetPassword({ authToken, deployment, password });
        await dispatch({
            // bidderID from token not response
            meta: {
                ...getSetPasswordAnalytics(getState(), userData.bidderId, attributionData),
                actionTime: Date.now(),
            },
            payload: userData,
            type: SET_PASSWORD_SUCCESS,
        });
        await dispatch(submitLogin(emailAddress, password, {}));
        return dispatch(openCompleteAccountModal());
    } catch (error) {
        dispatch({
            error: true,
            meta: { emailAddress },
            payload: error.error_message || error.message || error,
            type: SET_PASSWORD_FAIL,
        });
    }
};
